module.exports = __webpack_public_path__ + "static/jccgv-logo-5cf618efc853183d08aaf33168612843.png";